import { render } from "./UiDatePicker.vue?vue&type=template&id=39e3b45a&scoped=true&ts=true"
import script from "./UiDatePicker.vue?vue&type=script&lang=ts"
export * from "./UiDatePicker.vue?vue&type=script&lang=ts"

import "./UiDatePicker.vue?vue&type=style&index=0&id=39e3b45a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e3b45a"]])

export default __exports__